import { ActivityAttendance, CheckInCheckOutStep } from './checkInCheckOutCenter';

export enum VerificationRole {
  PARTICIPANT = 'PARTICIPANT',
  VOLUNTEER = 'VOLUNTEER',
  INSTRUCTOR = 'INSTRUCTOR',
  ORGANISATION = 'VOLUNTEER_ORGANIZATION'
}

export enum VerificationVolunteerType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE'
}

// What the retry validation screen shows for a validate profile error response
export interface AACValidateProfileError {
  title: string;
  description: string;
  fieldMessage: string;
}

export interface AACCheckInCheckOutResponse {
  checkInDate?: string;
  checkOutDate?: string;
}

export interface AACVolunteerData {
  attendeeId: string;
  attendeeName: string;
  attendeeNRIC: string;
  attendeeRole: 'EXTERNAL_INSTRUCTOR' | 'PARTICIPANT' | 'VOLUNTEER' | 'VOLUNTEER_ORGANIZATION';
  primaryCoordinatorName?: string;
  secondaryCoordinatorName?: string;
  noOfVolunteers?: number;
}

export interface AACProfileValidateResponse extends AACVolunteerData {
  eventName: string;
  eventStart: string;
  eventEnd: string;
  alreadyCheckedIn: boolean;
  checkInDate: string | undefined;
  alreadyCheckedOut: boolean;
  checkOutDate: string | undefined;
}

export interface AACCheckInCheckOutState {
  loading: boolean;
  step: CheckInCheckOutStep;
  volunteerData?: AACVolunteerData;
  checkInCheckOut?: AACCheckInCheckOutResponse;
  showSomethingWentWrong?: boolean;
  validateProfileError?: AACValidateProfileError;
  verificationRole?: VerificationRole;
  nric?: string;
  email?: string;
  selectedEvent?: ActivityAttendance;
  verificationType?: VerificationVolunteerType;
  verificationValue?: string;
  numberOfVolunteers?: number;
}
